import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_IS_OPEN_MODAL_WORKER_INFO: 'SET_IS_OPEN_MODAL_WORKER_INFO',
};
export const modalWorkerInfoMutationType = vuexEventPathGenerator(mutationType, 'modalWorkerInfo');
const mutations = {
    [mutationType.SET_IS_OPEN_MODAL_WORKER_INFO](state, workerCode) {
        state.isOpenModalWorkerInfo = workerCode;
    },
};
export default mutations;
